import { render, staticRenderFns } from "./TablaBusqueda.vue?vue&type=template&id=78f46a3a&"
import script from "./TablaBusqueda.vue?vue&type=script&lang=js&"
export * from "./TablaBusqueda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports